import React, { useEffect } from "react";
import BackdropLoader from "../backdropLoader/BackdropLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { object, string } from "yup";
import { useFormik } from "formik";
import Box from "@mui/material/Box";
import {
  emailAddress,
  emailAddressPlaceholder,
  forgotPasswordHeader,
  forgotPasswordSubHeader,
  invalidEmailAddress,
  loadingMsg,
  submit,
} from "../messages";
import {
  authOptionsFooterDivider,
  callAPIInterface,
  isTMA,
  sourceTelegramApp,
  sourceWebWallet,
} from "../constants";
import Text from "../text/Text";
import { Input } from "../input/Input";
import InputErrorMessage from "../inputErrorMessage/InputErrorMessage";
import Button from "../button/Button";
import CommonHeader from "../CommonHeader";
import CommonAuthHeader from "../options/CommonAuthHeader";

const ForgotPassword = ({ isFromOptions = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isFromLoginPage = location?.state?.isFromLoginScreen;

  useEffect(() => {
    if (!isFromLoginPage) {
      navigate("/login");
      return;
    }
  }, []);

  const handleForgotPassword = async (val) => {
    try {
      await callAPIInterface(
        "POST",
        "/forgot-password",
        JSON.stringify({
          ...val,
          source: isTMA() ? sourceTelegramApp : sourceWebWallet,
        })
      );
      navigate("/forgot-password-confirmation", { state: val });
    } catch (error) {}
  };

  const validationSchema = object({
    email: string().email(invalidEmailAddress),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: handleForgotPassword,
  });

  const {
    values,
    touched,
    errors,
    isValid,
    dirty,
    handleChange,
    handleSubmit,
    handleBlur,
    isSubmitting,
  } = formik;

  const defaultErrorMessageProps = {
    touched,
    errors,
  };
  return (
    <>
      <BackdropLoader
        open={isSubmitting}
        alt={loadingMsg}
        text={loadingMsg}
        customClass="loading-in-auth"
      />
      <CommonHeader icon="backArrow" />
      <CommonAuthHeader showSpeedLogo={false} sx={{ height: "100%" }}>
        <Box
          component="form"
          className="set-elements-vertically"
          onSubmit={handleSubmit}
        >
          <Box>
            <Text className="default-text" size={22} font="bold">
              {forgotPasswordHeader}
            </Text>
            <Text className="grey-text mt-8" size={14}>
              {forgotPasswordSubHeader}
            </Text>
            <Input
              customClass="mt-24"
              fullWidth
              showLabel
              label={emailAddress}
              placeholder={emailAddressPlaceholder}
              name="email"
              value={values.email}
              type="email"
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.email && Boolean(errors.email)}
            />
            <InputErrorMessage
              {...defaultErrorMessageProps}
              inputName="email"
            />
            {isFromOptions && authOptionsFooterDivider}
          </Box>
          <Box className={!isFromOptions ? "footer" : ""} left={0}>
            <Button
              fullWidth
              sx={!isFromOptions && { m: "14px 20px" }}
              variant="contained"
              label={submit}
              type="submit"
              disabled={!(isValid && dirty)}
              {...(!isFromOptions && { textClass: "font-14" })}
            />
          </Box>
        </Box>
      </CommonAuthHeader>
    </>
  );
};

export default ForgotPassword;
